import { ownerDocument, setNodeValue } from '../../../xmlUtility';

export const selectNodeListFromXPathEngine = (
    xPathEngine,
    contextNode,
    xPath,
) => xPathEngine.evaluateXPath(xPath, { context: contextNode }).toArray();

export function selectNodeFromXPathEngine(
    xPathEngine,
    xPath,
    context,
    errorMessage,
) {
    const nodeList = selectNodeListFromXPathEngine(xPathEngine, context, xPath);

    const selectedNode = nodeList?.[0] || null;

    if (!selectedNode && errorMessage) {
        throw new Error(errorMessage);
    }

    return selectedNode;
}

export function setNodeValueFromXPathEngine(
    xPathEngine,
    xpath,
    context,
    value,
) {
    const nodeItem = selectNodeFromXPathEngine(xPathEngine, xpath, context);

    if (!nodeItem) {
        console.error('Could not find node for XPath ' + xpath);
    } else {
        setNodeValue(nodeItem, value);
    }
}

export const selectNodes = selectNodeListFromXPathEngine;

export const selectNode = (xpathEngine, node, path) =>
    selectNodes(xpathEngine, node, path)[0] || null;

export function nodeWrapper(xPathEngine, node) {
    let nw;

    function setValue(value) {
        setNodeValue(node, value);
        return nw;
    }

    function sn(path) {
        return selectNode(xPathEngine, node, path);
    }

    nw = {
        setNodeValue: function (path, value) {
            setNodeValueFromXPathEngine(xPathEngine, path, node, value);
            return nw;
        },
        setValue: setValue,
        appendElement: function (qName) {
            var parts = qName.split(':');
            var doc = ownerDocument(node);

            var newNode =
                parts.length === 1
                    ? doc.createElement(qName)
                    : doc.createElementNS(
                          xPathEngine.nsr.getNamespace(parts[0]),
                          qName,
                      );

            node.appendChild(newNode);

            return nodeWrapper(xPathEngine, newNode);
        },
        selectNode: function (path) {
            var n = sn(path);

            return n && nodeWrapper(xPathEngine, n);
        },
        deleteNode: function (path) {
            var nodeToDelete = sn(path);

            if (nodeToDelete && nodeToDelete.parentNode) {
                nodeToDelete.parentNode.removeChild(nodeToDelete);
            }
            return nw;
        },
    };

    return nw;
}

export const isoDate = (date) => {
    return (date || new Date()).toISOString().substring(0, 19);
};
